<template>
  <div>
    <billing-table />
  </div>
</template>

<script>
import BillingsTable from "../components/billingsTable.vue";
export default {
  components: {
    "billing-table": BillingsTable
  }
};
</script>

<style></style>
